import { internal, template } from '../../vendor/elix.js';

function ErrorTextMixin(Base) {
  
  return class ErrorText extends Base {

    static get observedAttributes() {
      return [
        ...super.observedAttributes,
        'errortext'
      ];
    }

    get [internal.defaultState]() {
      return Object.assign(
        {},
        super[internal.defaultState],
        { errortext: undefined }
      );
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
      super.attributeChangedCallback(attributeName, oldValue, newValue);
      if (attributeName === 'errortext') {
        this.errortext = newValue;
      }
    }

    get errortext() {
      return this[internal.state].errortext;
    }

    set errortext(errortext) {
      this[internal.setState]({ errortext });
    }

    [internal.render](changed) {

      super[internal.render](changed);

      if (changed.errortext) {
        this.renderErrorText();
      }

    }

    renderErrorText() {

      const inputStateContainer = this.shadowRoot.querySelector('.inputStateContainer');

      if (inputStateContainer) {
        if (this.errortext) {
          inputStateContainer.classList.add('error');
        } else {
          inputStateContainer.classList.remove('error');
        } 
      }

      const errorTextElement = this.shadowRoot.querySelector('.errortext');
      errorTextElement.textContent = this.errortext || '';
    }

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

        <style>

          .errortext {
            color: var(--tp-error-text-mixin-font-color);
            display: none;
            font-family: var(--tp-error-text-mixin-font-family);
            font-size: var(--tp-error-text-mixin-font-size);
            letter-spacing: 0.77px;
            text-align: left;
            --webkit-font-smoothing: antialiased;
          }

          .inputStateContainer.error .errortext {
            display: block;
          }

        </style>

        <div class='errortext'></div>
        `
      );

    }

  }
}

export default ErrorTextMixin;
